import { connect } from 'react-redux';
import _hasIn from 'lodash/hasIn';
import { selectLocaleData } from 'selectors/locale-data';
import AvailabilityDetails from './AvailabilityDetails';

const mapStateToProps = (state, ownProps) => {
  const { offsetDaysOfWeek } = selectLocaleData(state);
  const { recurrence } = ownProps;
  const daysToDisplay = offsetDaysOfWeek.filter(day => _hasIn(recurrence, day.en));

  return {
    ...ownProps,
    daysToDisplay,
  };
};

export default connect(mapStateToProps)(AvailabilityDetails);
